// Lets components that live OUTSIDE the ReactFlowProvider (the Toolbar) find
// out where the middle of the visible canvas is, in flow coordinates.
// GraphEditor registers the provider because only it can call React Flow's
// project(). If nothing is registered yet we fall back to the old fixed spot.

let centerProvider = null;

export const registerCanvasCenterProvider = (fn) => {
  centerProvider = typeof fn === 'function' ? fn : null;
};

// Roughly how big a freshly added node is; used to centre it rather than
// hanging its top-left corner off the middle of the screen.
export const DEFAULT_NODE_SIZE = { width: 200, height: 80 };

// Top-left position that puts a node of `size` in the centre of the view.
export const getCanvasCenterPosition = (
  fallback = { x: 100, y: 100 },
  size = DEFAULT_NODE_SIZE
) => {
  try {
    const center = centerProvider ? centerProvider() : null;
    if (!center || !Number.isFinite(center.x) || !Number.isFinite(center.y)) {
      return fallback;
    }
    return { x: center.x - size.width / 2, y: center.y - size.height / 2 };
  } catch (_) {
    return fallback;
  }
};

// Nudge down-right while an existing node is sitting on the same spot, so
// adding several nodes in a row does not bury them on top of each other.
export const avoidOverlap = (position, nodes = [], step = 40, tolerance = 30) => {
  let { x, y } = position;
  const occupied = (px, py) => nodes.some((n) => (
    Math.abs((n.position?.x ?? 0) - px) < tolerance &&
    Math.abs((n.position?.y ?? 0) - py) < tolerance
  ));
  for (let i = 0; i < 20 && occupied(x, y); i += 1) {
    x += step;
    y += step;
  }
  return { x, y };
};
